export default {
  tab: {
    prospect: 'Prospect',
    index: 'Index',
    valuation: 'Valuation',
    liquidity: 'Liquidity',
    marketAnomaly: 'Market Anomaly',
  },

  indexSummary: {
    totalVolume: 'Total Volume: ',
    totalValue: 'Total Value: ',
    bnVnd: 'Bn. VND',
  },
};
